export const getBuyerProfileCompletionAPIUrl = (buyersKimera: string): string =>
    `${buyersKimera}/buyers/profile_completion`;
